import React from "react";
import teepeePic from "../assets/teepee.jpg";
import founders from "../assets/founders.jpg";
import background1 from "../assets/background1.jpg";
import logo from "../assets/AitapisskoFINAL_Flowers2.svg";
// import frontRoomPic from "../assets/frontroom3.jpg";
import road from "../assets/road.jpg";
import landAcknowledgement from "../assets/LandAcknowledgement.jpg";
import {
  Box,
  Carousel,
  Heading,
  Paragraph,
  ResponsiveContext,
  Text,
} from "grommet";
import CenteredColumn from "../components/CenteredColumn";
import ProfileCard from "../components/ProfileCard";
import { useAppContext } from "../stateManager/useAppContext";
import { PortableText } from "@portabletext/react";

const Home = () => {
  const { siteData } = useAppContext();
  const viewportSize = React.useContext(ResponsiveContext);

  // if (!siteData) {
  //   return null;
  // }

  const TeePeeBanner = () => {
    return (
      <Box
        fill="horizontal"
        background={{
          image: "url(" + teepeePic + ")",
          position: "center",
        }}
        height={"medium"}
        direction="row"
        justify="center"
      >
        <Box fill pad={{ vertical: "xlarge" }}>
          <Box width={"large"} alignSelf="center" gap={"medium"}>
            <Text
              textAlign="center"
              size={viewportSize === "small" ? "2xl" : "4xl"}
              weight={500}
              color="light-1"
              style={{ textShadow: "2px 2px 4px #000000" }}
            >
              <i>"A place with a living presence"</i>
            </Text>
          </Box>
        </Box>
      </Box>
    );
  };

  const Welcome = () => {
    return (
      <Box
        fill="horizontal"
        pad={{ vertical: "large", horizontal: "xlarge" }}
        direction="row"
        justify="center"
      >
        <CenteredColumn columnWidth="xlarge">
          <Box
            background={{
              image: "url(" + logo + ")",
              position: "top",
              opacity: 0.25,
              size: "contain",
            }}
            style={{
              textShadow:
                "rgb(250, 250, 250) 1px 1px 2px, rgb(250, 250, 250) 1px 1px 2px, rgb(250, 250, 250) 1px 1px 2px",
            }}
          >
            <CenteredColumn columnWidth="large">
              {siteData && siteData.homePage.welcomeText}
              <Text size="xlarge" alignContent="center" textAlign="center">
                <PortableText value={siteData && siteData.homePage.WelcomeText} />
              </Text>
            </CenteredColumn>
          </Box>
        </CenteredColumn>
      </Box>
    );
  };

  const LandAcknowledgement = () => {
    return (
      <Box
        fill="horizontal"
        background={{
          image: "url(" + landAcknowledgement + ")",
          position: "center",
        }}
        height={"medium"}
        direction="row"
        justify="center"
      >
        <Box fill pad={{ vertical: "xlarge", horizontal: "xlarge" }}>
          <Box
            width={"xlarge"}
            alignSelf="center"
            gap={"medium"}
            background={{ color: "rgba(0,0,0,0.6)" }}
            round="small"
          >
            <Text
              textAlign="center"
              size={viewportSize === "small" ? "medium" : "xlarge"}
              weight={500}
              color="light-1"
              style={{ textShadow: "2px 2px 4px #000000" }}
            >
              <PortableText value={siteData && siteData.homePage.LandAcknowledgement} />
            </Text>
          </Box>
        </Box>
      </Box>
    );
  };

  const MissionStatement = () => {
    return (
      <Box
        fill="horizontal"
        background={{
          image: "url(" + background1 + ")",
          position: "center",
        }}
        pad={{ vertical: "large", horizontal: "xlarge" }}
        direction="row"
        justify="center"
      >
        <CenteredColumn>
          <Box
            direction={viewportSize === "small" ? "column" : "row"}
            gap="small"
            alignContent="evenly"
          >
            <Box>
              <Heading level={2} alignSelf="center">
                Our Mission
              </Heading>
              <Text size={"large"} textAlign="center">
                <PortableText value={siteData && siteData.homePage.MissionStatement} />
              </Text>
            </Box>
            <Box
              direction="row"
              justify="center"
              width={viewportSize === "small" ? "medium" : "xlarge"}
              height={"medium"}
              background={{
                image: "url(" + founders + ")",
                position: "center",
              }}
              round="small"
              alignSelf="center"
            >
            </Box>
          </Box>
        </CenteredColumn>
      </Box>
    );
  };

  const OfficePicCarousel = () => {
    if (!siteData) {
      return null;
    }

    const numColumns = viewportSize === "small" ? 1 : 3;
    let memberIdx = 0;
    let views = [];

    while (memberIdx < siteData.providers.length) {
      if (views.length === 0 || views[views.length - 1].length === numColumns) {
        views.push([]);
      }
      views[views.length - 1].push(siteData.providers[memberIdx]);
      memberIdx += 1;
    }

    return (
      <Box
        fill="horizontal"
        background={{
          image: "url(" + road + ")",
          position: "bottom",
        }}
        pad={{ vertical: "large", horizontal: "xlarge" }}
        direction="row"
        justify="center"
      >
        <CenteredColumn>
          <Carousel play={2500} controls={false} alignSelf="center">
            {views.map((members,i) => {
              return (
                <Box
                  direction="row"
                  gap="medium"
                  pad={{ horizontal: "medium" }}
                  key={i}
                >
                  {members.map((member) => {
                    return (
                      <ProfileCard
                        teamMember={member}
                        pictureType={"office"}
                        pictureOnly
                      />
                    );
                  })}
                </Box>
              );
            })}
          </Carousel>
        </CenteredColumn>
      </Box>
    );
  };

  const skeleton = { message: { start: 'Loading', end: 'Content Loaded' } };

  return (
    <Box skeleton={!siteData ? skeleton : undefined}>
      <TeePeeBanner />
      <Welcome />
      <LandAcknowledgement />
      <MissionStatement />
      <OfficePicCarousel />
    </Box>
  );
};

export default Home;
